import './styles.scss';

import Banner from 'components/homepage/banner';
import CategoriesList from 'components/navigation/categories-list';
import AiMessagePromo from 'components/promote/ai-message-promo';
import AnniversaryPromo from 'components/promote/anniversary-promo';
import BirthdayPromo from 'components/promote/birthday-promo';
import CongratsPromo from 'components/promote/congrats-promo';
import GiftCardsPromo from 'components/promote/gift-cards-promo';
import GroupCardsPromo from 'components/promote/group-cards-promo';
import IOSAppPromo from 'components/promote/ios-app-promo';
import JustBecausePromo from 'components/promote/just-because-promo';
import RemindersPromo from 'components/promote/reminders-promo';
import Testimonials from 'components/promote/testimonials';
import TrialBenefits from 'components/promote/trial-benefits';
import React from 'react';

const HomePage = () => {
  return (
    <div id="home-page" className="home-page">
      <Banner variant="default"/>
      <GiftCardsPromo/>
      <GroupCardsPromo/>
      <IOSAppPromo/>
      <section className="promote-section">
        <BirthdayPromo/>
        <AnniversaryPromo/>
      </section>
      <AiMessagePromo/>
      <section className="promote-section">
        <CongratsPromo/>
        <JustBecausePromo/>
      </section>
      <section className="home-page-description">
        <RemindersPromo/>
      </section>
      <section className="testimonials-section">
        <Testimonials />
      </section>
      <section className="trial-benefits-section">
        <TrialBenefits />
      </section>
      <section className="categories-list-section">
        <CategoriesList />
      </section>
    </div>
  );
}

export default HomePage;
